// src/ExamResultsPortalPage.jsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from './Header';

export default function ExamResultsPortalPage() {
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const categories = [
    {
      id: 'exit-exam',
      icon: 'fa-graduation-cap',
      title: 'Exit Examination',
      desc: 'Final examination results for graduating students across all disciplines.',
      btnColor: 'hover:opacity-90',
      link: '/usernamepage',            // ← target route for exit exam
    },
    {
      id: 'ngat',
      icon: 'fa-clipboard-check text-green-600',
      title: 'NGAT Results',
      desc: 'National Graduate Admission Test results and performance analysis.',
      btnColor: 'bg-green-600 hover:bg-green-700',
      link: '/ngat-username',
    },
    {
      id: 'remedial',
      icon: 'fa-book-open text-purple-600',
      title: 'Remedial Examination',
      desc: 'Results for supplementary and improvement examinations.',
      btnColor: 'bg-purple-600 hover:bg-purple-700',
      link: '/remedial-usernamepage', // Now points to its own username entry page
    },
    {
      id: 'tvet',
      icon: 'fa-wrench text-orange-600',
      title: 'TVET Results',
      desc: 'Technical and Vocational Education Training examination results.',
      btnColor: 'bg-orange-600 hover:bg-orange-700',
      link: '/tvet-username', // Add this line
    },
    {
      id: 'tdp',
      icon: 'fa-chart-line text-red-600',
      title: 'TDP Results',
      desc: 'Teacher Development Program examination results and certifications.',
      btnColor: 'bg-red-600 hover:bg-red-700',
      link: '/tdp-username',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col">
      <Header />

      {/* Main Content */}
      <main className="container mx-auto px-4 py-8 flex-1">
        {/* Welcome Section */}
        <section className="text-center mb-12">
          <h2 className="text-3xl font-bold text-gray-800 mb-4">Welcome to Results Portal</h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Access your examination results from various national level examinations in one place.
          </p>
        </section>

        {/* Exam Categories */}
        <section className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {categories.map(({ id, icon, title, desc, btnColor, link }) => (
            <div
              key={id}
              className="bg-white rounded-xl shadow-sm hover:shadow-md transition-shadow p-6 border border-gray-100 flex flex-col"
            >
              <div className="flex items-center mb-4">
                <i 
                  className={`fa-solid ${icon} text-2xl mr-3`} 
                  style={{ color: id === 'exit-exam' ? 'rgb(18,82,166)' : undefined }}
                />
                <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
              </div>
              <p className="text-gray-600 mb-4 flex-1">{desc}</p>
              <button
                className={`w-full text-white py-2 rounded-lg transition-colors ${btnColor}`}
                style={{ 
                  backgroundColor: id === 'exit-exam' ? 'rgb(18,82,166)' : undefined 
                }}
                onClick={() => {
                  if (link) {
                    navigate(link);
                  }
                }}
              >
                View Results
              </button>
            </div>
          ))}
        </section>

        {/* Quick Links */}
        <section>
          <h3 className="text-xl font-semibold text-gray-800 mb-6">Quick Links</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[
              { icon: 'fa-circle-question', label: 'FAQs', link: '/faq' },
              { icon: 'fa-headset', label: 'Support', link: 'https://t.me/moeexitexamofficial' },
            ].map(({ icon, label, link }) => (
              <button
                key={icon}
                className="flex items-center p-4 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors"
                onClick={() => {
                  if (link) {
                    if (link.startsWith('http')) {
                      window.open(link, '_blank');
                    } else {
                      navigate(link);
                    }
                  }
                }}
              >
                <i className={`fa-solid ${icon} text-gray-600 mr-3`} />
                <span className="text-gray-700">{label}</span>
              </button>
            ))}
          </div>
        </section>
      </main>
    </div>
  );
}
